import { Component, ViewChild, HostListener, Inject, OnDestroy } from '@angular/core';
import { priceValidator, roundPriceControl, PRICE_MAX_LABEL } from '../validators/price.validator';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ProductsService, PRODUCT_IMAGE_WRONG_TYPE, splitProductImageFiles } from '@app/services/products/product.service';
import { ICategory } from '@app/models/category.interface';
import { CheckboxListComponent } from '@app/modules/products/components/checkbox-list/checkbox-list.component';
import { IArea } from '@app/models/area.interface';
import { IBarcode } from '@app/models/barcode.interface';
import {  distinctUntilChanged, filter, first, map, skipWhile, take, tap } from 'rxjs/operators';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { selectProductsDuplicateBarcodeState, selectProductState, selectProductsState } from '../store/selectors/products.selectors';
import * as ProductsActions from '@app/modules/products/store/actions/products.actions';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { SubSink } from 'subsink';
import { selectAreasState, selectCategoriesState } from '@app/modules/organization/store/selectors/organization.selectors';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { FormComponent } from '@app/modules/organization/categories-table/form/form.component';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { selectCountsCurrentTypeState } from '@app/modules/counts/store/selectors/counts.selectors';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';
import { ProductBarcodesService } from '@app/services/product-barcodes/product-barcodes.service';
import { selectCoreState, selectMeState } from '@app/core/store/core.selectors';
import { MessageModalComponent } from '@app/shared/components/message-modal/message-modal.component';
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { lang_selected$ } from '@app/shared/components/language-selector/language-selector.component';
import * as ReportsActions from '@app/modules/reports/store/actions/reports.actions';

const url = 'assets/scripts/printerCode.js?v9';
const url1 = 'assets/scripts/printerCode_old.js';
const urlBrother = 'assets/brother/brotherPrinterCode.js';
import * as CoreActions from '@app/core/store/core.action';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SanitizeStringPipe } from '@app/shared/pipes/sanitize-string.pipe';
import { ProductActivityDialogComponent } from '../product-activity-dialog/product-activity-dialog.component';
import { AssetBorrowDialogComponent } from '../asset-borrow-dialog/asset-borrow-dialog.component';
import { ProductStorageTreeviewComponent } from '@app/shared/components/product-storage-treeview/product-storage-treeview.component';
import { ConfirmModalComponent } from '@app/shared/components/confirm-modal/confirm-modal.component';
import { TreeItemFlatNode } from '@app/models/storage.interface';
import { ISerialPatterns } from '@app/models/serialpatterns.interface';
import { Router } from '@angular/router';
import { selectReportsState } from '@app/modules/reports/store/selectors/reports.selectors';
import { ReportsService } from '@app/services/reports/reports.service';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss']
})
export class ProductEditComponent implements OnDestroy {
  roundPrice = roundPriceControl;
  priceMaxLabel = PRICE_MAX_LABEL;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public checkedAreas;
  public checkedStorages: TreeItemFlatNode[] = [];
  public duplicateBarcodeMessageDetect = [];
  public duplicateSerialPatternsMessageDetect = [];
  public QytLimitData$ : any = 0;
  public selectedChip$: number = 0;
  public form: FormGroup = new FormGroup({
    prdID: new FormControl(),
    prdNameEn: new FormControl('', [Validators.required]),
    prdSKU: new FormControl(''),
    prdCode: new FormControl('', [Validators.required, Validators.maxLength(18)]),
    prdBrand: new FormControl(''),
    prdOnHand: new FormControl(''),
    prdPackageUOM: new FormControl(''),
    prdCatID: new FormControl(''),
    prdCountTypeID: new FormControl(''),
    prdCasePack: new FormControl(''),
    selectedAreas: new FormControl([]),
    selectedStorages: new FormControl([]),
    prdIsSerialized: new FormControl(false),
    prdIsAsset: new FormControl(false),
    prdAssetsNumber: new FormControl(''),
    storedAreas: new FormControl([]),
    counts: this.fb.array([]),
    prdCustomField1: new FormControl('', [Validators.maxLength(255)]),
    prdCustomField2: new FormControl('', [Validators.maxLength(255)]),
    barcodes: new FormControl([]),
    serialPatterns: new FormControl([]),
    prdDescription: new FormControl(''),
    // Tag names; the API stores them as "A, B".
    prdTags: new FormControl([]),
    alertEnabled: new FormControl(false),
    alertThreshold: new FormControl(null)
  });

  public loadAPI: Promise<any>;
  public barcodeSelectedIndex: number = 0;
  public serialPatternsSelectedIndex: number = 0;
  public settings$;
  public locPrdCustomFieldLabel1$: String = 'Counting Methods';
  public locPrdCustomFieldLabel2$: String = 'Counting Methods';
  public defaultCount;
  public categories$: ICategory[];
  public areas$: IArea[];
  public isPrdCodeValid$;
  public isBarcodeValid$: boolean = null;
  public isSerialPatternsValid$: boolean = null;
  public isBarcodeSingle$: boolean = null;
  public isStorageSingle$: boolean = null;
  public product$;
  public prdOnHand: number = 0;
  public prdMinQuantity: number = 0;
  public prdTotalOnHand: number = 0;
  public prdLastCounted: number = 0;
  public barcodes$: IBarcode[] = [];
  public serialPatterns$: ISerialPatterns[] = [];
  // Per-unit RFID tags; section only renders when the franchise flag is on.
  public rfidTags$: any[] = [];
  public rfidEnabled$: boolean = false;
  public isRfidValid$: boolean = true;
  public rfidError: string = '';
  public currentBarcode: string;
  public labelForm: FormGroup = new FormGroup({ input: new FormControl(0) });
  public printLabel: string = null;
  public masterCategories$: Subscription;
  public masterCategories;
  public isPrintDisabled: boolean = true;
  public isLoading: boolean = true;
  public isAllowedToLeave: boolean = true;
  public hasPrinter: boolean = false;
  public subs: SubSink = new SubSink;
  public selectedBarcode: string;
    public readProductOption: boolean = true;
  public multiBarcodeOption: boolean = false;
  public countingMethodsAddOption: boolean = false;
  public readStorageOption: boolean = false;
  public countingMethodsCountBy: boolean = false;
  public countingMethodsOrderBy: boolean = false;
  public countingMethodsDescriptionOption: boolean = false;
  public countingMethodsQuantityOption: boolean = false;
  public mls1Option: boolean = false;
  public mls2Option: boolean = false;
  public showStockInformation: boolean = false;
  public skuError:string = '';
  public barcodeError:string = '';
  public serialPatternsError:string = '';
  public showProductSerialNumberButton: boolean = false;
  public show_serialpattern: boolean = false;
  width_radio_text = '';
  close_button_margin = '';
  lang_selected: string;
  public subscription: Subscription;
  public printList = [
    {
      name: 'Dunnage Shelf Label (2 1/8" x 1")',
      value: 0
    },
    {
      name: 'Price Tag Label (2" x 3/4")',
      value: 2
    },
    {
      name: 'Shelf Label (3 1/2" x 1 1/8") - PDF417',
      value: 4
    },
    {
      name: 'Shelf Label (3 1/2" x 1 1/8") - QR Code',
      value: 5
    },
    {
      name: 'Shipping Label (2 1/8" x 4") - QR (Assets)',
      value: 7
    },
    {
      name: 'Shipping Label (2 1/8" x 4") - Barcode (Products)',
      value: 8
    }
  ];

  // Alert settings properties
  public alertSettings: any = null;
  public alertEnabled: boolean = false;
  public alertThreshold: number = null;
  public userLocationID: number;

  // Asset Module
  public locUsesAssetModule: number = 0;
  public locUsesSerializedModule: number = 0;

  // Serial UI (checkbox + pattern field) requires the core flag and the location Serialized Module
  get showSerialBlock(): boolean {
    return !!this.show_serialpattern && this.locUsesSerializedModule === 1;
  }
  // Product photos. The large frame shows the cover; the strip under it holds
  // the rest of the gallery. productImageUrl stays the cover's url so the rest
  // of this screen keeps working unchanged.
  public productImageUrl: string = '';
  public uploadingImage: boolean = false;
  public draggingImage: boolean = false;
  public productImages: any[] = [];
  public maxProductImages: number = 5;
  public assetConversionBlocked: boolean = false;
  public activeBorrowsForConversion: any[] = [];
  public assetBorrowInfo: { status: string; borrowerName?: string; location?: string } = null;

  @ViewChild('chipList') chipList;
  @ViewChild('chipInput') chipInput;
  @ViewChild('chipList1') chipList1;
  @ViewChild('chipInput1') chipInput1;
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return this.isAllowedToLeave;
  }

  // Product photo. Uploading replaces whatever was there; the API removes the
  // old file once the row points at the new one.
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);
    if (!files.length || this.matDialogData.finalized) { input.value = ''; return; }
    this.handleImageFiles(files, input);
  }

  onImageDragOver(event: DragEvent): void {
    if (this.matDialogData.finalized || this.uploadingImage) { return; }
    // Both are needed or the browser opens the file instead of dropping it.
    event.preventDefault();
    event.stopPropagation();
    this.draggingImage = true;
  }

  onImageDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.draggingImage = false;
  }

  onImageDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.draggingImage = false;
    if (this.matDialogData.finalized || this.uploadingImage) { return; }
    this.handleImageFiles(Array.from(event.dataTransfer?.files || []), null);
  }

  // Shared by the file picker and drag-and-drop. The picker's accept attribute
  // does not apply to a drop, so the type check lives here. Supported files go
  // up; the rest are named in a message instead of being ignored.
  private handleImageFiles(files: File[], input: HTMLInputElement | null): void {
    const { valid, invalid } = splitProductImageFiles(files);
    if (input) { input.value = ''; }
    if (invalid.length) {
      this._toastr.error(this._translation.instant('products.photoWrongTypeNamed', {
        names: invalid.map((f) => f.name).join(', ')
      }));
    }
    if (!valid.length) { return; }
    const room = this.maxProductImages - this.productImages.length;
    if (room <= 0 || valid.length > room) {
      // Clicking or dropping on the frame at the cap used to do nothing.
      this._toastr.warning(this._translation.instant('product.image.galleryFull', { max: this.maxProductImages }));
    }
    if (room <= 0) { return; }
    this.uploadImageQueue(valid.slice(0, room));
  }

  // Adds to the gallery one file at a time (each answer carries the whole
  // gallery). The API enforces the cap too.
  private uploadImageQueue(files: File[]): void {
    const file = files.shift();
    if (!file) { this.uploadingImage = false; return; }
    this.uploadingImage = true;
    this._products.addProductImage(this.matDialogData.prdID, file).pipe(first()).subscribe({
      next: (res: any) => {
        this.applyGallery(res?.images);
        this.uploadImageQueue(files);
      },
      error: (err: any) => {
        this._toastr.error(this._translation.instant(this.imageUploadErrorKey(err)));
        this.uploadImageQueue(files);
      }
    });
  }

  // 413 comes from the web server, 422 from the API's own size/type rules.
  private imageUploadErrorKey(err: any): string {
    if (err?.message === PRODUCT_IMAGE_WRONG_TYPE) { return 'products.photoWrongType'; }
    if (err?.status === 413) { return 'products.photoTooLarge'; }
    if (err?.status === 422) {
      const imageErrors: string[] = err?.error?.errors?.image || [];
      return imageErrors.some((m) => /kilobytes|size/i.test(m)) ? 'products.photoTooLarge' : 'products.photoWrongType';
    }
    return 'products.photoUploadFailed';
  }

  // Removes the cover, which promotes the next photo. Kept on the frame's
  // corner button so the gesture is the same as before.
  onRemoveImage(): void {
    if (this.matDialogData.finalized) { return; }
    const cover = this.productImages[0];
    if (!cover) { return; }
    this.onRemoveGalleryImage(cover);
  }

  onRemoveGalleryImage(image: any): void {
    if (this.matDialogData.finalized || !image?.id) { return; }

    this.uploadingImage = true;
    this._products.deleteProductImageById(this.matDialogData.prdID, image.id)
      .pipe(first()).subscribe({
        next: (res: any) => {
          this.applyGallery(res?.images);
          this.uploadingImage = false;
        },
        error: () => { this.uploadingImage = false; }
      });
  }

  onMakeCover(image: any): void {
    if (this.matDialogData.finalized || !image?.id || this.isCover(image)) { return; }

    this.uploadingImage = true;
    this._products.makeProductImageCover(this.matDialogData.prdID, image.id)
      .pipe(first()).subscribe({
        next: (res: any) => {
          this.applyGallery(res?.images);
          this.uploadingImage = false;
        },
        error: () => { this.uploadingImage = false; }
      });
  }

  isCover(image: any): boolean {
    return !!image && this.productImages.length > 0 && this.productImages[0].id === image.id;
  }

  get galleryIsFull(): boolean {
    return this.productImages.length >= this.maxProductImages;
  }

  private loadGallery(): void {
    if (!this.matDialogData?.prdID) { return; }
    this._products.getProductImages(this.matDialogData.prdID).pipe(first()).subscribe({
      next: (res: any) => {
        if (res?.max) { this.maxProductImages = res.max; }
        this.applyGallery(res?.images);
      },
      error: () => { }
    });
  }

  /**
   * The API always answers with the whole gallery, cover first, so the list is
   * replaced outright. Urls are cache-busted because a promoted or replaced
   * photo keeps its url and the browser would otherwise show the stale file.
   */
  private applyGallery(images: any[]): void {
    const stamp = Date.now();
    this.productImages = (images || []).map(image => ({
      ...image,
      displayUrl: image?.url ? image.url + '?v=' + stamp : '',
      displayThumbUrl: (image?.thumbUrl || image?.url) ? (image.thumbUrl || image.url) + '?v=' + stamp : ''
    }));
    this.productImageUrl = this.productImages.length ? this.productImages[0].displayUrl : '';
    // The catalog reads the cover from prdImageFileName; keep its row in step
    // so a removed or replaced cover does not linger there until a reload.
    if (this.matDialogData?.prdID) {
      this._store.dispatch(ProductsActions.patchProductInList({
        prdID: this.matDialogData.prdID,
        changes: { prdImageFileName: this.productImages.length ? this.productImages[0].fileName : null }
      }));
    }
  }

  constructor(
    public fb: FormBuilder,
    private _products: ProductsService,
    private _store: Store,
    public _translation: TranslateService,
    private _matDialog: MatDialog,
    private _matDialogRef: MatDialogRef<ProductEditComponent>,
    private store$: Store,
    private _reports: ReportsService,
    private router: Router,
    private _breakpoints: BreakpointService,
    @Inject(MAT_DIALOG_DATA) public matDialogData,
    private limitAccessService: LimitAccessService,
    private _toastr: ToastrService
  ) {

    // Get the user's location ID.
    this.subs.add(this.store$.select(selectMeState).pipe(
      skipWhile((me) => me == null),
      take(1)
    ).subscribe((me: any) => {
      this.userLocationID = me.usrLocID;
    }));

    this.store$.dispatch(ProductsActions.loadProduct({ prdID: this.matDialogData.prdID }));
    this.subs.add(combineLatest([
      this.store$.select(selectCategoriesState).pipe(skipWhile(categories => categories == null)),
      // this.store$.select(selectAreasState).pipe(
      //   skipWhile(areas => areas == null),
      //   tap((areas) => {
      //     this.checkedAreas = areas.filter(item => item.checked == true)
      //   })
      // ),
      this.store$.select(selectProductsDuplicateBarcodeState).pipe(
        skipWhile(duplicateBarcode => duplicateBarcode == null),
      )
    ]).pipe(
      map(([
        categories,
        //areas,
      ]) => {
        return {
          categories,
          //areas,
        }
      })
    ).subscribe(({ categories }) => {
      this.categories$ = categories;
      //this.areas$ = areas;
    }))

    this.store$
    .select(selectCoreState)
    .pipe(
      filter((res) => res !== undefined && res !== null), 
      tap((res) => {
        this.show_serialpattern = res.show_serialpattern;
      })
    ).subscribe();

    this.subs.add(this.store$.select(selectProductState).pipe(
      skipWhile((product) => product == null),
    ).subscribe((product) => {
      this.product$ = product;
      // Cover straight from the product row so the frame paints immediately,
      // then the gallery request fills in the rest of the strip.
      this.productImageUrl = this._products.productImageUrl(product.prdImageFileName);
      this.loadGallery();

      // Load asset borrow info - always update (reset if not present)
      if (product.assetBorrowInfo) {
        this.assetBorrowInfo = product.assetBorrowInfo;
      } else if (product.prdIsAsset) {
        // Reset to available if no borrow info but product is an asset
        this.assetBorrowInfo = { status: 'available', borrowerName: null, location: null };
      } else {
        this.assetBorrowInfo = null;
      }

      if(this.product$.prdTotalOnHand!=null && this.product$.prdTotalOnHand!=undefined && this.product$.prdTotalOnHand!='' && this.product$.prdTotalOnHand!=0){
        this.prdTotalOnHand = this.product$.prdTotalOnHand;
      }

      if(this.product$.prdLastCounted!=null && this.product$.prdLastCounted!=undefined && this.product$.prdLastCounted!='' && this.product$.prdLastCounted!=0){
        this.prdLastCounted = this.product$.prdLastCounted;
      }
      
      if(product.pmh!=undefined && product.pmh.length>0){
          this.checkedStorages = product.pmh.map(storage => ({ 
            storageStructureID: storage.storageStructureID, 
            item: storage.name,
            path: storage.storagePath 
        }));
        if(this.checkedStorages.length>0){
          this.showStockInformation = true;
        }

      }
      this.form.patchValue({
        prdID: this.product$?.prdID,
        prdNameEn: new SanitizeStringPipe().transform(this.product$?.prdNameEn),
        prdSKU: new SanitizeStringPipe().transform(this.product$?.prdSKU),
        prdCode: new SanitizeStringPipe().transform(this.product$?.prdCode),
        prdBrand: new SanitizeStringPipe().transform(this.product$?.prdBrand),
        prdOnHand: this.product$?.prdOnHand,
        prdPackageUOM: this.product$?.prdPackageUOM,
        prdCasePack: this.product$?.prdCasePack,
        prdMinQty: this.product$?.prdMinQty,
        prdIsSerialized: this.product$?.prdIsSerialized?true:false,
        prdIsAsset: this.product$?.prdIsAsset?true:false,
        prdAssetsNumber: this.product$?.prdAssetsNumber || '',
        prdCatID: this.product$?.prdCatID,
        prdClearID: this.product$?.prdClearID,
        prdCountTypeID: this.product$?.prdCountTypeID,
        //selectedAreas: [],
        selectedStorages: [],
        prdMinQty2: this.product$?.prdMinQty2,
        prdCustomField1: this.product$?.prdCustomField1,
        prdCustomField2: this.product$?.prdCustomField2,
        prdDescription:  new SanitizeStringPipe().transform(this.product$.prdDescription),
        prdTags: (this.product$?.prdTags || '').split(',').map(t => t.trim()).filter(t => !!t),
      });

      // Asset Number is required for asset products
      if (this.product$?.prdIsAsset) {
        this.form.get('prdAssetsNumber')?.setValidators([Validators.required]);
        this.form.get('prdAssetsNumber')?.updateValueAndValidity();
      }

      if(product.isOnHandUpdated!=true){
        // The update response has no barcodes list; rebuild only from a real list
        // so a storage auto-save does not empty the barcodes on screen (and in the
        // next save payload, where an explicit [] deletes them).
        if (Array.isArray(this.product$.barcodes)) {
          this.barcodes$ = [];

          this.product$.barcodes.map(item => {
            this.barcodes$.push({
              barcodeData: new SanitizeStringPipe().transform(item.barcodeData),
              barcodeID: item.barcodeID,
              barcodePrdID: item.barcodePrdID,
            });
          });
        }

        // The update response carries serialPatterns as a single string (first pattern),
        // not the list. Only rebuild from a real list so a storage change (auto-save)
        // does not wipe the patterns on screen and in the next save payload.
        if (Array.isArray(this.product$.serialPatterns)) {
          this.serialPatterns$ = [];
          this.product$.serialPatterns?.map(item => {
            this.serialPatterns$.push({
              serialPattern: new SanitizeStringPipe().transform(item.serialPattern),
              productSerialNumberPatternsID: item.productSerialPatternsID,
              prdID: item.prdID,
            });
          });
        };

        this.rfidEnabled$ = this.product$.rfidEnabled == 1;
        this.rfidTags$ = [];
        if (Array.isArray(this.product$.rfidTags)) {
          this.product$.rfidTags?.map(item => {
            this.rfidTags$.push({
              rfidID: item.rfidID,
              rfidValue: new SanitizeStringPipe().transform(item.rfidValue),
            });
          });
        }

      }

      //this.barcodes$ = this.product$.barcodes;
      this.areas$ = this.product$.psa;
      this.isLoading = false;

      // Header MSL comes from the default count method (same rule as the
      // health check), and is always reassigned so a cleared MSL or another
      // product's value never sticks in the header.
      if(Array.isArray(this.product$.countType) && this.product$.countType.length > 0){
        const defaultCount = this.product$.countType.find(item => item.pcmIsDefaultCountMethod == 1) ?? this.product$.countType[0];
        const minQty = Number(defaultCount?.pcmMinQty1);
        this.prdMinQuantity = isNaN(minQty) ? 0 : minQty;
      }
      if(product.isOnHandUpdated!=true){
        // Clear FormArray to prevent duplicates on reload
        this.counts.clear();

        this.product$.countType?.map(item => this.counts.insert(0, this.setCounts(item)));
      }
      
      this.form.valueChanges.subscribe(() => {
        this.setDefaultCount();
      });

      if (this.product$.psa && this.product$.psa.length > 0) {
        this.store$.dispatch(OrganizationActions.setPsa({ psa: this.product$.psa }));
      }

      if(this.barcodes$?.length > 0){
        localStorage.setItem('prdBarcode', this.barcodes$[0].barcodeData);
        this.barcodes$[0].selected = true;
      }
      if(this.serialPatterns$?.length > 0){
        localStorage.setItem('prdSerialPattern', this.serialPatterns$[0].serialPattern);
        this.serialPatterns$[0].selected = true;
      }

      // Load alert settings for this product
      this.loadAlertSettings();

    }));
    this.loadAPI = new Promise(() => {
      this.loadScript();
      this.loadScriptOld();
      this.loadBrotherScript();
    });
  }



  public loadScript() {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.hasPrinter = true;
  }


  public loadScriptOld() {
    let node = document.createElement('script');
    node.src = url1;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.hasPrinter = true;
  }

  public loadBrotherScript() {
    let node = document.createElement('script');
    node.src = urlBrother;
    node.type = 'module';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  ngOnInit(): void {

    this.subscription = lang_selected$.subscribe(value => {
      this.lang_selected = value;
      if(this.lang_selected != 'en-ca'){
        this.width_radio_text = 'width_radio_text';
        this.close_button_margin = 'close_button_margin';
      }else{
        this.width_radio_text = '';
        this.close_button_margin = '';
      }
    });

    this.getQytLimitData();
    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        this.readProductOption = this.limitAccessService.getAccess('products', 'products', '','');
        let resultMultiBarcode = this.limitAccessService.getAccess('products', 'products', 'form','multi_barcode');
        let resultCountingMethodsAdd = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_add');
        let resultCountingMethodsCountBy = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_count_by');
        let resultCountingMethodsOrderBy = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_order_by');
        let resultCountingMethodsDescription = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_description');
        let resultCountingMethodsQuantity = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_quantity');
        let resultMls1 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls1');
        let resultMls2 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls2');
        this.readStorageOption = this.limitAccessService.getAccess('products', 'storages', '','');
        this.multiBarcodeOption = resultMultiBarcode;
        this.countingMethodsAddOption = resultCountingMethodsAdd;
        this.countingMethodsCountBy = resultCountingMethodsCountBy;
        this.countingMethodsOrderBy = resultCountingMethodsOrderBy;
        this.countingMethodsDescriptionOption = resultCountingMethodsDescription;
        this.countingMethodsQuantityOption = resultCountingMethodsQuantity;
        this.mls1Option = resultMls1;
        this.mls2Option = resultMls2;
      }
    });

    this.store$.select(selectSettingsState).subscribe((settings) => {
      this.settings$ = settings;
      this.locUsesAssetModule = Number(settings.locUsesAssetModule) || 0;
      this.locUsesSerializedModule = Number(settings.locUsesSerializedModule) || 0;
      if (settings.locEnableCustomField1 == 1) {
        this.locPrdCustomFieldLabel1$ = this.settings$.locPrdCustomFieldLabel1;
      }

      if (settings.locEnableCustomField2 == 1) {
        this.locPrdCustomFieldLabel2$ = this.settings$.locPrdCustomFieldLabel2;
      }

      if (this.settings$.locEnableAutoBarcodeGen == true && this.barcodes$.length === 0) {
        this._products.onGeneratePrdCode().pipe(take(2)).subscribe(res => {

          if (this.settings$.locEnableAutoBarcodeGen && res != null && this.barcodes$.length === 0) {
            const value = String(res);
            this.barcodes$.push({ barcodeData: value, barcodeID: null, barcodePrdID: this.product$?.prdID ?? null });
            this.form.patchValue({ barcodes: this.barcodes$ });
          }

        });
      }
    });

    this._reports.getReportsProductSerialNumber('created_at', 'desc', '', '', this.matDialogData.prdID, '1').pipe(
      map((data) => {
        if(data.total!=null && data.total!=undefined && data.total!='' && data.total>0){
          this.showProductSerialNumberButton = true;
          return data.total;
        }
        else{
          this.showProductSerialNumberButton = false;
          return 0;
        }
      })
    ).subscribe();

    // Auto-fill SKU from Asset Number (only if SKU is empty or was auto-filled)
    this.form.get('prdAssetsNumber')?.valueChanges.subscribe((assetNumber: string) => {
      const isAsset = this.form.get('prdIsAsset')?.value;
      const currentSKU = this.form.get('prdCode')?.value || '';

      // Copy if SKU is empty OR if Asset Number starts with current SKU (meaning it was auto-filled)
      if (isAsset && assetNumber && (currentSKU === '' || assetNumber.startsWith(currentSKU))) {
        this.form.get('prdCode')?.setValue(assetNumber, { emitEvent: false });
      }
    });

  }

  onAddCategory() {
    const dialogRef = this._matDialog.open(FormComponent, {
      data: {
        type: 'Add',
        area: null
      },
      width: this._breakpoints.isMobile() === true ? "100vw" : "30vw",
    });

    dialogRef.afterClosed().subscribe(saved => {
      if (saved == true) {
        this.setTimeoutEvent()
      }
    });
  }

  setTimeoutEvent(){
    setTimeout(() => {
      this.form.get('prdCatID').setValue(this.categories$[this.categories$.length - 1].prdCatID);
    }, 200);
  }


  setCounts(item): FormGroup {
    return this.fb.group({
      pcmID: new FormControl(item.pcmID),
      pcmDesc: new FormControl(item.pcmDesc, Validators.required),
      pcmItemQty: new FormControl(item.pcmItemQty, Validators.required),
      pcmCost: new FormControl(item.pcmCost, [priceValidator()]),
      pcmRetail: new FormControl(item.pcmRetail, [priceValidator()]),
      pcmMinQty1: new FormControl(item.pcmMinQty1),
      pcmMinQty2: new FormControl({ value: item.pcmMinQty2, disabled: this.settings$?.locEnableMultiMinQty == 0 }),
      pcmIsDefaultCountMethod: new FormControl(item.pcmIsDefaultCountMethod == 1 ? item.pcmIsDefaultCountMethod : 0, Validators.required),
      pcmIsDefaultOrderMethod: new FormControl(item.pcmIsDefaultOrderMethod == 1 ? item.pcmIsDefaultOrderMethod : 0, [Validators.required]),
    });
  }

  addCount() {
    this.counts.push(this.createCount());

    /**
     * Forces validation
     */
    this.form.markAllAsTouched();
  }

  createCount(): FormGroup {
    return this.fb.group({
      // Readonly fields keep the default, otherwise the required validator can never pass
      pcmDesc: new FormControl(this.countingMethodsDescriptionOption ? '' : 'Each', [Validators.required]),
      pcmCost: new FormControl('', [priceValidator()]),
      pcmRetail: new FormControl('', [priceValidator()]),
      pcmMinQty1: new FormControl('', [Validators.required]),
      pcmMinQty2: new FormControl(''),
      pcmIsDefaultCountMethod: new FormControl(0, [Validators.required]),
      pcmIsDefaultOrderMethod: new FormControl(0, [Validators.required]),
      // Asset quantity is forced to 1 and readonly, so it keeps the default
      pcmItemQty: new FormControl(this.countingMethodsQuantityOption && !this.form.get('prdIsAsset')?.value ? '' : 1, [Validators.required]),
    });
  }

  get counts() {
    return this.form.get("counts") as FormArray;
  }

  onRemoveCount(i, row) {
    this.counts.removeAt(i);

    if (row.controls.pcmIsDefaultCountMethod.value == "1") {
      this.counts.controls[0].patchValue({
        pcmIsDefaultCountMethod: 1
      });
    }

    if (row.controls.pcmIsDefaultOrderMethod.value == "1") {
      this.counts.controls[0].patchValue({
        pcmIsDefaultOrderMethod: 1
      });
    }
  }

  async onSubmit(saveType: string='') {

    if(this.matDialogData.finalized){
      return;
    }
    const barcodeValue = (document.getElementById('chipInput') as HTMLInputElement).value; 

    if (!this.form.controls['prdIsSerialized'].value) {
      this.form.controls['serialPatterns'].setValue([]);  
    }

    let serialPatternsValue = '';
    if(this.showSerialBlock && this.form.get('prdIsSerialized').value){
      serialPatternsValue = (document.getElementById('chipInput1') as HTMLInputElement).value; 
    }
    //sku and barcode serialpattern validate...
    let prdCheck = await this.checkPrdCode();
    let barcodeCheck = await this.checkBarcodes(barcodeValue);
    let serialPatternsCheck = await this.checkSerialPatterns([serialPatternsValue]);
    //let storageCheck = this.checkedStorages.length > 0 ? true : false;

   
    if (!prdCheck) {
      return false;
    }
    if (!barcodeCheck) {
      return false;
    }
    if (!serialPatternsCheck) {
      return false;
    }
    // if (!storageCheck) {
    //   return false;
    // }
    
    if (barcodeValue.trim() !== '') {
      if(this.QytLimitData$<(this.barcodes$.length+1) && this.QytLimitData$!=0){
        this._store.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('errormessage.limitbarcode'),
          show_upgrade: true
        }));
        return;
      }else{

        this.barcodes$.push({
          barcodeData: barcodeValue,
          barcodeID: null,
          barcodePrdID: null,
        }); 

        this.barcodes$ = this.barcodes$.filter((item, index, array) => {
          return array.findIndex(obj => obj.barcodeData === item.barcodeData) === index;
        });

        (document.getElementById('chipInput') as HTMLInputElement).value = ''; 
      }
    }


    if (serialPatternsValue.trim() !== '') {
        this.serialPatterns$.push({
          serialPattern: serialPatternsValue,
          productSerialNumberPatternsID: null,
          prdID: null,
        }); 

        this.serialPatterns$ = this.serialPatterns$.filter((item, index, array) => {
          return array.findIndex(obj => obj.serialPattern === item.serialPattern) === index;
        });

        (document.getElementById('chipInput1') as HTMLInputElement).value = '';       
    }


    if(saveType!='storage'){
      this._matDialogRef.close();
    }

    const selectedAreas = this.areas$?.filter(item => item.checked === true).map(item => item.prdAreaID);
    this.form.patchValue({
      selectedAreas,
      selectedStorages: this.checkedStorages.map(storage => ({
        storageStructureID: storage.storageStructureID,
        path: storage.path,
        name: storage.item
      })),
      barcodes: this.barcodes$,
      serialPatterns: this.serialPatterns$
    });
    this.isAllowedToLeave = true;

    // Save alert settings
    this.saveAlertSettings();

    this.store$.dispatch(ProductsActions.updateProduct({ form: this.form.value }));
   
    if(this.form.value.selectedStorages.length>0){
      this.showStockInformation = true;
    }
    else{
      this.showStockInformation = false;
    }

    //console.warn('form to submit', this.form.value);
    this.store$.select(selectCountsCurrentTypeState).pipe(first()).subscribe(({ currentType, currentId }) => {
      switch (currentType) {
        case 'count':
          this.store$.dispatch(CountsActions.loadCount({ invID: currentId, active: 'prdNameEn', direction: 'asc' }));
          break;
        case 'financial':
          this.store$.dispatch(CountsActions.loadFinancial({ invID: currentId, active: 'prdNameEn', direction: 'asc' }));
          break;
        case 'reorder':
          this.store$.dispatch(CountsActions.loadReorder({ invID: currentId, active: 'prdNameEn', direction: 'asc', pcmType: 1 }));
          break;
        case 'po':
          this.store$.dispatch(CountsActions.loadPO({ invID: currentId, prdMinQty: 1 }));
          break
        case 'printcount':
          this.store$.dispatch(CountsActions.loadPrintCount({ invID: currentId }));
          break;
        case 'excel':
          this.store$.dispatch(CountsActions.loadExcel({ invID: currentId, active: 'prdNameEn', direction: 'asc' }));
          break;
      }
    });


          
        //   else{
        //     return this.form.get('barcodes').setErrors({ valid: false });;
        //   }
        // });

    
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
    this.form.reset();
    this.store$.dispatch(ProductsActions.resetProduct());
    this.store$.dispatch(OrganizationActions.resetPsa());
    this._products.onSetIsAllowedToLeave(true);
  }

  onToggleDefault(row, i) {
    this.counts.controls.forEach((item: any, current) => {
      if (current != i) {
        item.patchValue({
          pcmIsDefaultCountMethod: "0"
        })
      }
    });
    this.setDefaultCount();
  }

  onToggleOrder(row, i) {
    this.counts.controls.forEach((item: any, current) => {
      if (current != i) {
        item.patchValue({
          pcmIsDefaultOrderMethod: "0"
        })
      }
    });
    this.setDefaultCount();
  }

  onRemove(item: IArea) {
    this.store$.dispatch(OrganizationActions.checkArea({ prdAreaID: item.prdAreaID, checked: false }))
  }
  
  onStorageRemove(item: TreeItemFlatNode) {
    this.checkedStorages = this.checkedStorages.filter(storage => storage.storageStructureID !== item.storageStructureID);
    
    if (this.checkedStorages.length === 0) {
      this.isStorageSingle$ = true;
    }
    else{
      this.isStorageSingle$ = false;
      if(!this.matDialogData.finalized){
        this.onSubmit('storage');
      }
    }
    
  }

  onOpenAreas(): void {
    this._matDialog.open(CheckboxListComponent, {
      width: this._breakpoints.isMobile() === true ? "100vw" : "30vw",
    });

  }

  onOpenStorages(): void {
    const isAsset = this.form.get('prdIsAsset')?.value;
    const isMobileStorage = this._breakpoints.isMobile() === true;
    const dialog = this._matDialog.open(ProductStorageTreeviewComponent, {
      width: isMobileStorage ? "100vw" : "30vw",
      // Override Material's default 80vw cap so the picker is truly full-width on phones.
      maxWidth: isMobileStorage ? "100vw" : "80vw",
      data:{
        "storages" : this.checkedStorages,
        "title": this._translation.instant('storeInStorage'),
        "singleSelect": isAsset  // Asset için tek seçim
      }
    });

    dialog.afterClosed().subscribe(res => {
      if(res!=undefined && res!='cancel'){
        // Asset için sadece tek storage al
        if (isAsset && res.length > 1) {
          this.checkedStorages = [res[res.length - 1]];
        } else {
          this.checkedStorages = res;
        }
        if(!this.matDialogData.finalized){
          //this.form.get('selectedStorages').setErrors({ valid: true });
          this.isStorageSingle$ = false;
          this.onSubmit('storage');
        }
      }
    });
  }

  onBarcodeKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      const inputValue = this.chipInput.nativeElement.value.trim();
      if(this.duplicateBarcodeMessageDetect[inputValue] == true)
      {
        delete this.duplicateBarcodeMessageDetect[inputValue];
        return false;
      }
      this.duplicateBarcodeMessageDetect[inputValue] = true;
    }
  }

  onSerialPatternsKeyDown(event: KeyboardEvent) {
    const allowedKeys = /^[A-Za-z0-9-_]*$/;
    const key = event.key;
    
    if (!allowedKeys.test(key) && key !== 'Backspace' && key !== 'Tab' && key !== 'Enter') {
      event.preventDefault(); 
    }

    if (event.key === 'Enter' || event.keyCode === 13) {
      const inputValue = this.chipInput1.nativeElement.value.trim();
      if(this.duplicateSerialPatternsMessageDetect[inputValue] == true)
      {
        delete this.duplicateSerialPatternsMessageDetect[inputValue];
        return false;
      }
      this.duplicateSerialPatternsMessageDetect[inputValue] = true;
    }
  }


  // RFID tags are saved live through their own endpoints (not staged with the
  // product form): uniqueness is server-authoritative and a conflict must
  // immediately tell the user which product already owns the tag.
  onRfidSubmit(event) {
    if (this.matDialogData.finalized) { return; }
    const value = (event.value || '').trim();
    if (value === '') { return; }

    this._products.addRfidTags(this.product$.prdID, [value]).pipe(first()).subscribe({
      next: (res) => {
        this.isRfidValid$ = true;
        this.rfidError = '';
        if (event.input) { event.input.value = ''; }
        (res?.created || []).forEach((t) => {
          this.rfidTags$.push({ rfidID: t.rfidID, rfidValue: t.rfidValue });
        });
      },
      error: (err) => {
        this.isRfidValid$ = false;
        const conflict = err?.error?.conflicts?.[0];
        this.rfidError = conflict
          ? `RFID tag is already assigned to ${conflict.prdNameEn} (${conflict.prdCode})`
          : (err?.error?.message || 'Failed to add RFID tag');
      }
    });
  }

  onRfidDelete(index) {
    if (this.matDialogData.finalized) { return; }
    const tag = this.rfidTags$[index];
    if (!tag) { return; }
    this._products.deleteRfidTag(tag.rfidID).pipe(first()).subscribe({
      next: () => {
        this.rfidTags$.splice(index, 1);
        this.isRfidValid$ = true;
        this.rfidError = '';
      },
      error: () => {
        this.isRfidValid$ = false;
        this.rfidError = 'Failed to delete RFID tag';
      }
    });
  }

  onBarcodeSubmit(event) {
    this.form.controls['barcodes'].setErrors(null);
    if(this.matDialogData.finalized){
      return;
    }

    if(this.duplicateBarcodeMessageDetect[event.value] == true)
    {
      return false;
    }
    
    if (event.value.trim() != "") {
      if(this.QytLimitData$>this.chipList.chips.length || this.QytLimitData$==0){
        if(this.multiBarcodeOption ==false){
          if(Object.keys(this.barcodes$).length >= 1){
            this.isBarcodeSingle$ = false;
            return;
          }else{
            this.isBarcodeSingle$ = true;
          }
        }
        let prdCode = this.form.get('prdCode').value.trim();
        const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
        const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
        this._products.validateProductData('barcode',prdCode, event.value, serialPatternsValue,this.product$.prdID).pipe(first()).subscribe(({ error, message }) => {
          this.isBarcodeValid$ = !error;
          if(this.isBarcodeValid$ == true){
            this.chipInput.nativeElement.value = "";
            
            this.barcodes$.push({
              barcodeData: event.value,
              barcodeID: null,
              barcodePrdID: this.product$.prdID
            });

            this.barcodes$ = this.barcodes$.filter((item, index, array) => {
              return array.findIndex(obj => obj.barcodeData === item.barcodeData) === index;
            });
          }
          else{
            this.barcodeError = message;
            this.form.controls['barcodes'].setErrors({ valid: false });
          }
        });

      } else{
  
        this._store.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('errormessage.limitbarcode'),
          show_upgrade: true
        }));
      }
      
    }
  }

  onSerialPatternsSubmit(event) {
    
    this.form.controls['serialPatterns'].setErrors(null);
    if(this.duplicateSerialPatternsMessageDetect[event.value] == true)
    {
      return false;
    }
    
    if (event.value.trim() != "") {
        let prdCode = this.form.get('prdCode').value.trim();
        const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
        const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
        this._products.validateProductData('serialPattern',prdCode, barcodeValue, event.value,this.product$.prdID).pipe(first()).subscribe(({ error, message }) => {
          this.isSerialPatternsValid$ = !error;
          this.serialPatternsError = message;
          if(this.isSerialPatternsValid$ == true){
            this.form.controls['serialPatterns'].setErrors(null);
            this.chipInput1.nativeElement.value = "";
            
            this.serialPatterns$.push({
              serialPattern: event.value,
              productSerialNumberPatternsID: null,
              prdID: this.product$.prdID
            });

            this.serialPatterns$ = this.serialPatterns$.filter((item, index, array) => {
              return array.findIndex(obj => obj.serialPattern === item.serialPattern) === index;
            });
          }
          else{
            this.form.controls['serialPatterns'].setErrors({ valid: false });
          }
        });  
    }
  }

  closeDialog() {
    this._matDialogRef.close();
  }

  goToSerialNumber() {
    this._matDialogRef.close();
    setTimeout(() => {
      this.router.navigate(['/products/serial-number', this.product$.prdID]);
    }, 300);
  }

  onSelectLabel(event, i) {
    this.isPrintDisabled = false;
    this.printLabel = this.onTruncate(event.target.dataset.name);
    localStorage.setItem('labelType', i);
    this.setDefaultCount();
  }
  private onTruncate(input) {
    if (input.length > 5) return input.substring(0, 8) + '...';
    return input;
  }
  onSelectBarcode(index) {
    this.barcodes$[this.barcodeSelectedIndex].selected = false;
    this.barcodes$[index].selected = true;
    this.barcodeSelectedIndex = index;
    localStorage.setItem('prdBarcode', this.barcodes$[index].barcodeData);
  }

  onSelectSerialPatterns(index) {
    this.serialPatterns$[this.serialPatternsSelectedIndex].selected = false;
    this.serialPatterns$[index].selected = true;
    this.serialPatternsSelectedIndex = index;
    localStorage.setItem('prdSerialPattern', this.serialPatterns$[index].serialPattern);
  }

  onBarcodeDelete(index) {
    this.barcodes$.splice(index, 1);
    if(this.multiBarcodeOption ==false){
      if(Object.keys(this.barcodes$).length <= 1){
        this.isBarcodeSingle$ = true;
      }
    }
  }

  onSerialPatternsDelete(index) {
    this.serialPatterns$.splice(index, 1);
  }
  

  onBarcodeKeyUp(event) {
    this.form.controls['barcodes'].setErrors({ required: false });
    this.form.controls['barcodes'].setErrors(null);
    this.isBarcodeValid$ = true;
    this.isBarcodeSingle$ = true;
  }

  onSerialPatternsKeyUp(event) {
    this.form.controls['serialPatterns'].setErrors(null);
    this.isSerialPatternsValid$ = true;
  }

  onStorageKeyUp(event) {
    this.isStorageSingle$ = false;
  }



  private setDefaultCount(): void {
    const selected = this.barcodes$?.find(item => item.selected == true);
    this.defaultCount = this.counts.value.find(item => item.pcmIsDefaultCountMethod == 1);
    localStorage.setItem('prdRetail', this.defaultCount?.pcmRetail);
    localStorage.setItem('prdCost', this.defaultCount?.pcmCost);
    localStorage.setItem('prdBarcode', selected?.barcodeData);
    localStorage.setItem('prdNameEn', this.form.get('prdNameEn').value);
    localStorage.setItem('prdCode', this.form.get('prdCode').value);
    localStorage.setItem('prdCasePack', this.form.get('prdCasePack').value);
    localStorage.setItem('prdID', this.product$?.prdID ?? '');
    localStorage.setItem('prdAssetsNumber', this.form.get('prdAssetsNumber')?.value ?? '');
    localStorage.setItem('prdIsAsset', this.form.get('prdIsAsset')?.value ? '1' : '0');
    if (this.checkedStorages?.length > 0) {
      localStorage.setItem('storageStructureID', this.checkedStorages[0].storageStructureID?.toString());
      localStorage.setItem('storagePrint', 'false');
    }
  }

  onValidatePrdCode(event) {
    this.checkPrdCode();
  }

  checkPrdCode(): Promise<boolean> {
    if (this.form.controls['prdCode'].hasError('required') || this.form.controls['prdCode'].hasError('maxLength')) {
      return Promise.resolve(false);
    }
  
    return new Promise<boolean>((resolve) => {
      let prdCode = this.form.get('prdCode').value.trim();
      
      if (prdCode === '') {
        this.form.controls['prdCode'].setErrors({ required: true });
        resolve(false);
      } else if (prdCode.length > 18) {
        this.form.controls['prdCode'].setErrors({ maxLength: true });
        resolve(false);
      } else {
        let prdCode = this.form.get('prdCode').value.trim();
      
        const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
        const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
        this._products.validateProductData('sku', prdCode, barcodeValue,serialPatternsValue, this.product$.prdID).subscribe(({ error, message }) => {
          if (error) {
            this.skuError = this._translation.instant(message);
            this.form.controls['prdCode'].setErrors({ valid: false });
            resolve(false);
          } else {
            if (!this.form.controls['prdCode'].hasError('maxLength') && !this.form.controls['prdCode'].hasError('required')) {
              this.form.controls['prdCode'].setErrors(null);
            }
            resolve(true);
          }
        });


      }
    });
  }
  
checkBarcodes(barcodeValue:any): Promise<boolean> {
  this.form.controls['barcodes'].setErrors(null);

  return new Promise<boolean>((resolve, reject) => {
    let prdCode = this.form.get('prdCode').value.trim();
    const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
    this._products.validateProductData('barcode',prdCode, barcodeValue, serialPatternsValue, this.product$.prdID).pipe(first()).subscribe(({ error, message }) => {
      if (error) {
        this.isBarcodeValid$ = false;
        this.barcodeError = this._translation.instant(message);
        this.form.controls['barcodes'].setErrors({ valid: false });
        resolve(false);
      } else {
        this.barcodeError = '';
        resolve(true);
      }
    });
  });
}
  
checkSerialPatterns(serialPatternsValue:any): Promise<boolean> {
  this.form.controls['serialPatterns'].setErrors(null);
  return new Promise<boolean>((resolve, reject) => {
    let prdCode = this.form.get('prdCode').value.trim();
    const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
    this._products.validateProductData('serialPattern', prdCode,barcodeValue,  serialPatternsValue, this.product$.prdID).pipe(first()).subscribe(({ error, message }) => {
      if (error) {
        this.isSerialPatternsValid$ = false;
        this.serialPatternsError = this._translation.instant(message);
        this.form.controls['serialPatterns'].setErrors({ valid: false });
        resolve(false);
      } else {
        this.serialPatternsError = '';
        resolve(true);
      }
    });
  });
}

async getQytLimitData(){
  await this._store.select(selectMeState).pipe(
    skipWhile(res => res == null),
  ).subscribe((data) => {
    this.QytLimitData$ = data.settingQtyLimiter.barcodes;
  });
}

openInventoryInformation() {
  const dialogRef = this._matDialog.open(ProductActivityDialogComponent, {
    data:{
      prdID: this.product$.prdID,
      prdNameEn: this.form.get('prdNameEn').value,
      prdCode: this.form.get('prdCode').value,
      // Printer settings
      locEnablePrinting: this.settings$.locEnablePrinting,
      locEnableBrotherPrinting: this.settings$.locEnableBrotherPrinting,
      locPrdCustomFieldLabel1: this.settings$.locPrdCustomFieldLabel1,
      locPrdCustomFieldLabel2: this.settings$.locPrdCustomFieldLabel2,
      prdCustomField1: this.product$.prdCustomField1,
      prdCustomField2: this.product$.prdCustomField2,
      customFieldPrintable: this.settings$.customFieldPrintable,
      countType: this.product$.countType,
      barcodes: this.product$.barcodes,
      prdCasePack: this.product$.prdCasePack,
      prdAssetsNumber: this.form.get('prdAssetsNumber')?.value || this.product$.prdAssetsNumber || '',
      prdIsAsset: this.form.get('prdIsAsset')?.value ? 1 : 0,
      prdIsSerialized: this.product$?.prdIsSerialized
    },
    minWidth: '60vw',
    minHeight: '400px',
    maxWidth: '90vw',
    maxHeight: '80vh',
    panelClass: 'ProductActivity__Modal'
  });

  dialogRef.afterClosed().subscribe(data => {
    // Reload product data if override was performed
    if (data) {
      this.store$.dispatch(ProductsActions.loadProduct({ prdID: this.matDialogData.prdID }));
    }
  });
}

openAssetBorrowDialog() {

  // Asset için storage bilgisini de gönder
  const storageInfo = this.checkedStorages && this.checkedStorages.length > 0
    ? {
        storageStructureID: this.checkedStorages[0].storageStructureID,
        storagePath: this.checkedStorages[0].path
          ? this.checkedStorages[0].path + ' -> ' + this.checkedStorages[0].item
          : this.checkedStorages[0].item
      }
    : null;

  // Get prdAssetsNumber - check form first, then product$ object
  const formValue = this.form.get('prdAssetsNumber')?.value;
  const productValue = this.product$?.prdAssetsNumber;
  const prdAssetsNumber = formValue || productValue || '';

  console.log('openAssetBorrowDialog - prdAssetsNumber debug:', {
    formValue,
    productValue,
    finalValue: prdAssetsNumber,
    product$: this.product$
  });

  const dialogRef = this._matDialog.open(AssetBorrowDialogComponent, {
    data: {
      prdID: this.product$.prdID,
      prdNameEn: this.form.get('prdNameEn').value,
      prdCode: this.form.get('prdCode').value,
      prdAssetsNumber: prdAssetsNumber,
      prdBarcode: this.barcodes$?.find(item => item.selected == true)?.barcodeData || '',
      prdRetail: this.counts?.value?.find(item => item.pcmIsDefaultCountMethod == 1)?.pcmRetail || '',
      storageInfo: storageInfo
    },
    width: '680px',
    maxWidth: '95vw',
    maxHeight: '80vh',
    panelClass: 'AssetBorrow__Modal'
  });

  dialogRef.afterClosed().subscribe(result => {
    // Always refresh product when dialog closes to get latest borrow status
    this.store$.dispatch(ProductsActions.loadProduct({ prdID: this.matDialogData.prdID }));

    // Borrow data changed: also refresh the product list (with its active
    // filters) so the on-hand and borrowed chip update behind this modal.
    if (result?.refresh) {
      this.store$.select(selectProductsState).pipe(first()).subscribe(state => {
        this.store$.dispatch(ProductsActions.loadProducts({
          filterType: state.filterType,
          filterID: state.filterID,
          query: state.query,
          prdStorage: state.prdStorage,
          prdCatID: state.prdCatID,
          prdIsAsset: state.prdIsAsset
        }));
      });
    }
  });
}

getSerializedTooltipMessage(): string {
  if (this.product$?.serialLocked) {
    return this._translation.instant('product.serializedLocked');
  }
  if (this.product$?.prdIsLockSerialized === 1) {
    return this._translation.instant('product.serialized.receiving.exists');
  } else if (this.product$?.prdIsLockSerialized === 2) {
    return this._translation.instant('product.serialized.receiving.serialnumber');
  }
  return "";
}

loadAlertSettings(): void {
  if (!this.product$ || !this.userLocationID) {
    return;
  }

  this._products.getAlertSettings(this.product$.prdID, this.userLocationID).subscribe({
    next: (response) => {
      if (response.alertSettings) {
        this.alertSettings = response.alertSettings;
        this.alertEnabled = !!response.alertSettings.alert_enabled;
        this.alertThreshold = response.alertSettings.alert_threshold;

        // Update form controls
        this.form.patchValue({
          alertEnabled: this.alertEnabled,
          alertThreshold: this.alertThreshold
        });
      }
    },
    error: (error) => {
      console.error('Error loading alert settings:', error);
    }
  });
}

saveAlertSettings(): void {
  if (!this.userLocationID || !this.product$) {
    return;
  }

  const alertData = {
    locID: this.userLocationID,
    alert_enabled: this.form.value.alertEnabled ? true : false,
    alert_threshold: this.form.value.alertThreshold || null
  };

  this._products.saveAlertSettings(this.product$.prdID, alertData).subscribe({
    next: (response) => {
      console.log('Alert settings saved successfully');
    },
    error: (error) => {
      console.error('Error saving alert settings:', error);
    }
  });
}

openAlertModal(): void {
  import('../product-alert-modal/product-alert-modal.component').then(m => {
    const dialogRef = this._matDialog.open(m.ProductAlertModalComponent, {
      data: {
        products: [this.product$],
        enableAlert: !this.alertEnabled,  // Toggle: if disabled, open enable modal & vice versa
        locID: this.userLocationID,
        singleProduct: true
      },
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.loadAlertSettings();
      }
    });
  });
}

getStockStatus(): string | null {
  // No badge when min quantity is missing or 0
  if (!this.prdMinQuantity || this.prdMinQuantity <= 0) {
    return null;
  }

  const onHand = this.product$?.prdTotalOnHand ?? 0;

  if (onHand <= 0) {
    return 'out';  // Out of Stock
  }

  if (onHand < this.prdMinQuantity) {
    return 'low';  // Low Stock
  }

  return 'healthy';  // Healthy Stock
}

/**
 * Handle asset toggle with validation
 * Asset → Normal conversion is blocked if there are active borrows
 */
async onAssetToggle(event: any) {
  const newValue = event.checked;
  const currentValue = this.product$?.prdIsAsset;

  // If trying to convert from Asset to Normal
  if (currentValue && !newValue) {
    try {
      const validation = await this._products
        .validateAssetConversion(this.product$.prdID, false)
        .toPromise();

      if (!validation.canConvert) {
        // Block the conversion and show warning
        this.assetConversionBlocked = true;
        this.activeBorrowsForConversion = validation.activeBorrows || [];

        // Revert the toggle
        this.form.patchValue({ prdIsAsset: true });

        return;
      }
    } catch (error) {
      console.error('Error validating asset conversion:', error);
      // Revert on error
      this.form.patchValue({ prdIsAsset: true });
      return;
    }
  }

  // Clear any previous warning
  this.assetConversionBlocked = false;
  this.activeBorrowsForConversion = [];

  // Asset toggle'ı açıldığında
  if (newValue) {
    // Asset için quantity = 1 zorla
    const countsArray = this.form.get('counts') as FormArray;
    countsArray.controls.forEach(control => {
      control.patchValue({ pcmItemQty: 1 });
    });

    // For assets, keep only the first storage
    if (this.checkedStorages.length > 1) {
      this.checkedStorages = [this.checkedStorages[0]];
    }
  }
}

/**
 * Clear the asset conversion warning
 */
clearAssetConversionWarning() {
  this.assetConversionBlocked = false;
  this.activeBorrowsForConversion = [];
}

}